module.exports = __webpack_public_path__ + "img/check-mark-blue.9efee38a.svg";